"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _Loading = _interopRequireDefault(require("../../Icons/Loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var ariaLabel = _ref.ariaLabel,
      classes = _ref.classes,
      clickMethod = _ref.clickMethod,
      dataTestId = _ref.dataTestId,
      isDisabled = _ref.isDisabled,
      isFullWidth = _ref.isFullWidth,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      size = _ref.size,
      text = _ref.text,
      type = _ref.type,
      variant = _ref.variant;
  return /*#__PURE__*/_react.default.createElement("button", {
    id: dataTestId,
    className: (0, _classnames.default)('cta', "cta--".concat(variant), {
      'cta--full-width': isFullWidth,
      'cta--small': size === 'small',
      'cta--is-loading': isLoading
    }, classes),
    type: type === 'submit' ? 'submit' : 'button',
    "data-testid": dataTestId,
    onClick: clickMethod,
    disabled: isDisabled || isLoading,
    "aria-label": ariaLabel
  }, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "cta__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Loading.default, {
    classes: (0, _classnames.default)({
      'loading--small': size === 'small'
    })
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "cta__label"
  }, isLoading && loadingText ? loadingText : text));
};

Button.propTypes = {
  /**
   Optional. Customizes the aria-label value.
   */
  ariaLabel: _propTypes.default.string,

  /**
   Optional. Allows the component to accept custom classes.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Needed if type is 'button'.
   */
  clickMethod: (0, _reactRequiredIf.default)(_propTypes.default.func, function (props) {
    return props.type === 'button';
  }),

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios. Defaults to null.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Disables the button if true.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Gives the button a width of 100% of it's container.
   */
  isFullWidth: _propTypes.default.bool,

  /**
   Optional. Shows loading spinner icon if true.
   */
  isLoading: _propTypes.default.bool,

  /**
   Optional. Shows this text when isLoading is true.
   */
  loadingText: _propTypes.default.string,

  /**
   Optional. Button size options: 'large', 'small'. Defaults to 'large'.
   */
  size: _propTypes.default.oneOf(['large', 'small']),

  /**
   Required.
   */
  text: _propTypes.default.string.isRequired,

  /**
   Optional. Button type options: 'button', 'submit'.
   */
  type: _propTypes.default.oneOf(['button', 'submit']),

  /**
   Optional. Button variant options: 'primary', 'secondary', 'alternate', 'text-primary', 'text-secondary'. Defaults to 'primary'.
   */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'alternate', 'text-primary', 'text-secondary'])
};
Button.defaultProps = {
  ariaLabel: null,
  classes: '',
  clickMethod: function clickMethod() {},
  dataTestId: null,
  isDisabled: false,
  isFullWidth: false,
  isLoading: false,
  loadingText: null,
  size: 'large',
  type: 'button',
  variant: 'primary'
};
var _default = Button;
exports.default = _default;